<template>
  <div class="mb-4">
    <span class="table-div mb-2"><b>{{title}}</b></span>
    <vs-table :title="title" max-items="3" :pagination="data.length > 3" v-model="selected" :data="data" @selected="handleSelected">
      <template slot="thead">
        <vs-th :key="i" :sort-key="field_list[i]" v-for="(e, i) in columns">{{e}}</vs-th>
      </template>

      <template slot-scope="{data}">
        <colgroup ref="colgrouptable">
          <col v-for="(e, i) in widths" :key="i" :name="`col-`+i" :width="e+`%`"/>
        </colgroup>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr[field]" :key="i" v-for="(field, i) in field_list">
            <vs-button class="no-pointer-event inline-block" type="border" size="small" :color="stati[tr[field]]" v-if="stati[tr[field]]">{{tr[field]}}</vs-button>
            <span v-else-if="tr[field] === 'data_completamento'">{{$tariffe.formatDate(tr[field])}}</span>
            <span v-else>{{tr[field]}}</span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>

</template>

<script>
export default {
    name: "sidebar-table",
    data() {
      return {
        selected: null,
        stati: {
          'Accettato': 'success',
          'Rifiutato': 'danger',
          'Firmato': 'dark',
          'In attesa': 'warning'
        },
      }
    },
    props: {
            data: Array,
            columns: Array,
            field_list: Array,
            title: String,
            widths: Array,
    },
    methods: {
      handleSelected() {
        console.log(this.selected);
        this.$emit('selected', this.selected)
      },
    }
}
</script>
